import { CreateNS } from '../lib/createAPIBuilder';
import { decorateAccessorWithDeprecationNotice } from '../lib/decorateAccessorWithDeprecationNotice';

const AB_TEST_DEPRECATION_MESSAGE =
    'DEPRECATION NOTICE: Access of key is considered deprecated and may be removed in future releases. Please use Optimizely instead.';

export const installAPIStartupData = (namespace: CreateNS) => {
    namespace(null)(({ prop, deps, logger }) => {
        prop(
            'startupData',
            decorateAccessorWithDeprecationNotice({
                accessor: deps.getStartupData,
                deprecatedKeys: ['AB_Test', 'AB_Test_Multi'],
                deprecationMessage: AB_TEST_DEPRECATION_MESSAGE,
                logger,
            }),
            {
                setter: deps.setStartupData,
                shouldNotManipulate: true,
            },
        );
    });
};
